import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Common } from "@root/components/common/CommonTypes";
import GS from "@root/ts/GlobalSetting";
import { Emitter } from "strict-event-emitter";



export default class CountrySelect extends ComponentBase implements Common.InputComponent
{
  iti: any;
  emitter: Emitter<{ change: [value: string, isOk: boolean]; }>;

  _isOk: boolean = false;

  input: HTMLInputElement;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    let input = this.input = this.$root[0] as HTMLInputElement;

    this.iti = window.intlTelInput(input, {
      initialCountry: GS.DEFAULT_COUNTRY,
      nationalMode: true,
      preferredCountries: [GS.DEFAULT_COUNTRY],
      autoPlaceholder: "off",
    });

    input.readOnly = true;

    input.addEventListener("countrychange", () =>
    {
      this.update();
    });

    this.$root.find("input, select").attr("tabindex", "-1");
  }

  update()
  {
    // console.log(this.iti.getSelectedCountryData());
    let value = this.iti.getSelectedCountryData();
    this._isOk = Boolean(value);
    this.input.value = value.name;    

    this.emitter.emit("change", this.getValue(), this._isOk);
  }

  getValue(): any
  {
    let data: any = this.iti.getSelectedCountryData();

    return {name: data.name, iso2: data.iso2};
  }

  setValue(iso2: string)
  {
    this.iti.setCountry(iso2);
    this.update();
  }

  isOk(): boolean
  {
    return this._isOk;
  }

  reset()
  {
    this.iti.setCountry(GS.DEFAULT_COUNTRY);
    this.update();
  }
}